var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("html", [
    _vm._m(0),
    _c("body", [
      _c("div", { staticClass: "capa1" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row mt-5" }, [
            _c("div", { staticClass: "mx-auto p-4 col-lg-6 col-md-6 col-1" }),
            _c("div", { staticClass: "col-md-4 col-lg-4 col-9" }, [
              _c("h6", { staticClass: "text-white" }, [
                _vm._v("Negociação de Dívidas"),
              ]),
              _c("h1", { staticClass: "col-11 pl-0 text-white" }, [
                _vm._v("Condições especiais para você ficar no azul"),
              ]),
              _c("h6", { staticClass: "mb-5 text-white" }, [
                _vm._v(
                  "As melhores condições para você quitar as dívidas do seu cartão e dos demais produtos Porto."
                ),
              ]),
              _c(
                "a",
                {
                  staticClass: "btn mx-auto btn-lg btn-secondary",
                  attrs: { href: "#" },
                  on: { click: _vm.login },
                },
                [_vm._v("Negociar cartão")]
              ),
            ]),
            _c("div", { staticClass: "col-md-1 col-lg-1 col-1" }),
          ]),
        ]),
      ]),
      _vm._m(1),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("head", [
      _c("meta", { attrs: { charset: "utf-8" } }),
      _c("meta", {
        attrs: {
          name: "viewport",
          content: "width=device-width, initial-scale=1",
        },
      }),
      _c("link", { attrs: { rel: "icon", href: "img/favicon.ico" } }),
      _c("title", [_vm._v("Porto - Portal de Autonegociação")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "sec10 bg-light" }, [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "row justify-content-center text-center mb-5" },
          [
            _c("div", { staticClass: "col-md-12 text-dark" }, [
              _c("h2", { staticClass: "py-4" }, [
                _vm._v(
                  "Como fazer a negociação online do seu Cartão de Crédito Porto Bank "
                ),
              ]),
            ]),
          ]
        ),
        _c(
          "div",
          { staticClass: "row d-flex justify-content-center text-dark" },
          [
            _c("div", { staticClass: "col-6 col-lg-3 p-2 pl-3 pr-4" }, [
              _c("img", {
                staticClass: "img-fluid d-block mb-3",
                attrs: { src: "img/ic01.jpg" },
              }),
              _c("h5", [_vm._v("Identifique-se fazendo o login.")]),
            ]),
            _c("div", { staticClass: "col-6 col-lg-3 p-2 pr-4 pl-3" }, [
              _c("img", {
                staticClass: "img-fluid d-block mb-3",
                attrs: { src: "img/ic02.jpg" },
              }),
              _c("h5", [_vm._v("Selecione a melhor opção para você.")]),
            ]),
            _c("div", { staticClass: "col-6 col-lg-3 p-2 pr-4 pl-3" }, [
              _c("img", {
                staticClass: "img-fluid d-block mb-3",
                attrs: { src: "img/ic03.jpg" },
              }),
              _c("h5", {}, [_vm._v("Gere o boleto e faça o pagamento.")]),
            ]),
            _c("div", { staticClass: "col-6 col-lg-3 p-2 pr-4 pl-3" }, [
              _c("img", {
                staticClass: "img-fluid d-block mb-3",
                attrs: { src: "img/ic04.jpg" },
              }),
              _c("h5", {}, [
                _vm._v("Pronto! Tudo certo com a sua negociação."),
              ]),
            ]),
          ]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }